export default {
    namespaced: true,
    state: {
        stripeGateway: 'Stripe',
    },
    mutations: {},
    actions: {},
    getters: {
        getBillingAddress(state, getters, rootState, rootGetters) {
            let addresses = rootGetters['address/getAddresses'];

            return addresses ? addresses.find(address => address.is_billing === true) : null;
        },

        getCardEnding(state, getters, rootState, rootGetters) {
            let user = rootGetters['account/getUser'];

            return (user || {}).card_ending || null;
        },

        hasCardAttached: (state, getters) => getters.getCardEnding !== null,

        is3DSEnabled: () => process.env.VUE_APP_SCA_ENABLED === 'true',

        getStripeGateway: (state) => state.stripeGateway,

    },
};
